import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { BetaTag } from "../Widgets/BetaTag/BetaTag";
import "./IntegrationCard.scss";

interface IProps {
    name?: string;
    description?: string;
    imagePath?: string;
    onClick?: () => void;
    betaVersion?: boolean;
}

export const IntegrationCard: React.FC<IProps> = (props) => {
    return (
        <div className="integrationCard" onClick={props.onClick}>
            <div className="iconTag">
                {props.imagePath && <img alt="alt" src={props.imagePath} className="iconIntegration" />}
                {props.betaVersion && <BetaTag />}
            </div>
            <div className="integrationCardText">
                {props.name && <div className="integrationCardName">{props.name}</div>}
                {props.description && <div className="integrationCardDescription">{props.description}</div>}
            </div>
        </div>
    );
};
